import React from 'react';
import { Sun, Moon } from 'lucide-react';
import Logo from './Logo';

const Navbar = ({ theme, toggleTheme }) => {
  return (
    <nav className="navbar">
      <div className="container nav-content">
        <a href="/" className="logo">
          <Logo />
        </a>
        
        <div className="nav-actions">
          <button onClick={toggleTheme} className="theme-toggle" aria-label="Toggle theme">
            {theme === 'light' ? <Moon size={20} /> : <Sun size={20} />}
          </button>
          
          <button className="btn-primary">
            Join Beta
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
